export class CommodityType {
    ID;
    SpeciesID;
    CommodityName;
    constructor({id, speciesID, commodityName}) {
        this.ID = id;
        this.SpeciesID = speciesID;
        this.CommodityName = commodityName;
    }
}